/* eslint-disable */
L.Layer.CanvasParticules = L.Layer.extend({
	initialize: function(props) {
		this._opts = props;
		this._raster = {};
		this._points = [];
		this.debugColors = ['red', 'white', 'orange'];
	},

	getEvents: function() {
		var events = {
			zoomend: this._onDidZoom,
		};
		return events;
	},

	setOptions: function(options) {
		var self = this;
		_.each(options, function(value, key) {
			if (_.keys(self._opts).indexOf(key) >= 0) {
				self._opts[key] = value;
			}
		});
		this.onRemove();
		this.initialize(this._opts);
		this.onAdd(this._map);
	},

	_isInBbox: function(lat, lng) {
		var bounds = this._opts.bounds;
		return (
			lat < this._opts.bounds.max.y &&
			lat > this._opts.bounds.min.y &&
			lng < this._opts.bounds.max.x &&
			lng > this._opts.bounds.min.x
		);
	},

	_latLngRand: function() {
		return {
			lng: this._opts.bounds.min.x + Math.random() * this._boundsWidthDeg,
			lat: this._opts.bounds.min.y + Math.random() * this._boundsHeightDeg,
		};
	},

	_latLngToPt: function(latLng) {
		return {
			x: Math.round(
				(latLng[1] - this._opts.bounds.min.x) * this._boundsLngPixelPerDeg
			),
			y: Math.round(
				(this._opts.bounds.max.y - latLng[0]) * this._boundsLatPixelPerDeg
			),
		};
	},

	onAdd: function(map) {
		var self = this;
		this._map = map;
		this._opts.param.isError = false;
		this._buildRaster().then(function() {
			self._canvas = L.DomUtil.create(
				'canvas',
				'leaflet-layer leaflet-layer-particule'
			);
			self._ctx = self._canvas.getContext('2d');
			self._initPts();
			self._onDidZoom();
			if(!self._map) return;
			self._map.getPanes().overlayPane.appendChild(self._canvas);
			self.animationId = window.requestAnimationFrame(self._animate());
		});
		if (this._opts.debug) console.log(this);
	},

	_buildRaster: function() {
		var self = this;
		return new Promise(function(resolve, reject) {
			_.each(self._opts.imgUri, function(uri, i) {
				self._loadImg(uri, self._opts.bounds).then(
					function(raster) {
						var id = 'p' + i;
						self._raster[i] = raster;
						self._raster[i].ctx.canvas.id = id;
						if (document.getElementById(id))
							document.getElementById(id).remove();
						if (self._opts.debug)
							document.body.append(self._raster[i].ctx.canvas);
						resolve();
					},
					function(error) {
						self._opts.param.isError = true;
						reject();
					}
				);
			});
		});
	},

	_loadImg: function(uri) {
		var self = this;
		return new Promise(function(resolve, reject) {
			var img = new Image();
			img.crossOrigin = 'Anonymous';
			img.onload = function() {
				var canvas = document.createElement('canvas');
				var ctx = canvas.getContext('2d');
				canvas.width = img.width;
				canvas.height = img.height;
				ctx.drawImage(img, 0, 0, img.width, img.height);
				self._opts.onReady();
				resolve({
					imgData: ctx.getImageData(0, 0, img.width, img.height),
					ctx: ctx,
				});
			};
			img.onerror = function() {
				reject();
			};
			img.src = uri;
		});
	},

	_initPts: function() {
		for (
			var i = 0;
			i < (this._opts.debug ? 10 : this._opts.param.cardinal);
			i++
		) {
			var pt = { i: i };
			this._initPt(pt);
			this._points.push(pt);
		}
	},

	_initPt: function(pt) {
		// set geo position
		pt.dst = pt.src = this._latLngRand();

		// set screen position
		pt.pDst = pt.pSrc = this._latLngToPt([pt.src.lat, pt.src.lng]);

		// set age
		pt.maxAge = Math.floor(Math.random() * this._opts.param.maxAge);
		pt.age = 0;
	},

	_movePts: function() {
		if (!this._map) return;
		var b = this._map.getBounds();
		for (var i = 0; i < this._points.length; i++) {
			var pt = this._points[i];
			if (
				pt.src.lat >= b._southWest.lat &&
				pt.src.lat <= b._northEast.lat &&
				pt.src.lng > b._southWest.lng &&
				pt.src.lng <= b._northEast.lng
			) {
				var valuesAt = this.getValueAt({
					lat: pt.src.lat,
					lng: pt.src.lng,
					i: pt.i,
				});
				var force = valuesAt.windf;
				var deg = valuesAt.windd;
				var rad = deg * 0.017453292519943295;

				// check if value and coords is not null
				if (
					pt.age > pt.maxAge ||
					force == null ||
					rad == null ||
					isNaN(force) ||
					isNaN(rad) ||
					!pt.src.lat ||
					!pt.src.lng ||
					!pt.dst.lat ||
					!pt.dst.lng ||
					!this._isInBbox(pt.dst.lat, pt.dst.lng)
				) {
					this._initPt(pt);
					continue;
				}

				var velocity = force / this._opts.param.velocity;
				// up src geo position
				pt.src.lat = pt.dst.lat;
				pt.src.lng = pt.dst.lng;

				// up src screen position
				pt.pSrc = this._latLngToPt([pt.src.lat, pt.src.lng]);

				// up dst geo position
				pt.dst.lat += (0 + velocity) * Math.cos(rad);
				pt.dst.lng += (0 + velocity) * Math.sin(rad);

				// up dst screen position
				pt.pDst = this._latLngToPt([pt.dst.lat, pt.dst.lng]);

				// up values and age
				pt.force = force;
				pt.dir = deg;
				pt.age++;
			} else {
				this._initPt(pt);
			}
		}
	},

	_drawPts: function() {
		var prev = this._ctx.globalCompositeOperation;
		this._ctx.globalCompositeOperation = 'destination-in';
		this._ctx.fillStyle = 'rgba(0, 0, 0, ' + this._opts.param.fade + ')';
		if (this._opts.debug) this._ctx.fillStyle = 'rgba(0, 0, 0, 0)';
		this._ctx.fillRect(0, 0, this._canvas.width, this._canvas.height);
		this._ctx.globalCompositeOperation = prev;

		this._ctx.globalAlpha = this._opts.param.globalAlpha || 0.6;
		this._ctx.strokeStyle = this._opts.param.color || 'white';
		this._ctx.lineWidth = this._opts.param.width || 1;
		this._ctx.lineWidth = 2;

		for (var i = 0; i < this._points.length; i++) {
			var pt = this._points[i];
			this._ctx.beginPath();
			this._ctx.moveTo(pt.pSrc.x, pt.pSrc.y);
			this._ctx.lineTo(pt.pDst.x, pt.pDst.y);
			this._ctx.stroke();
			if (this._opts.debug) {
				this._ctx.font = '10px';
				this._ctx.fillStyle = this.debugColors[pt.i]
					? this.debugColors[pt.i]
					: 'lime';
				this._ctx.fillRect(pt.pDst.x - 0.5, pt.pDst.y - 0.5, 2, 2);
				this._ctx.fillText(i, pt.pDst.x + 4, pt.pDst.y + 4);
				this._ctx.fillText(
					'dg ' + pt.dst.lng.toFixed(2) + '; ' + pt.dst.lat.toFixed(2),
					pt.pDst.x + 4,
					pt.pDst.y + 16
				);
				this._ctx.fillText(
					'px ' + pt.pDst.x + '; ' + pt.pDst.y,
					pt.pDst.x + 4,
					pt.pDst.y + 28
				);
				if (pt.force)
					this._ctx.fillText(
						pt.force.toFixed(2) + 'm/s ',
						pt.pDst.x + 4,
						pt.pDst.y + 40
					);
				if (pt.dir)
					this._ctx.fillText(
						pt.dir.toFixed(2) + '°',
						pt.pDst.x + 4,
						pt.pDst.y + 52
					);
			}
		}

		this._ctx.globalAlpha = 1;
	},

	_animate: function(ms) {
		var self = this;
		return function(ms) {
			if (
				self._raster &&
				self._raster.windf != null &&
				self._raster.windd != null
			) {
				self._movePts();
				self._drawPts();
				if (self._opts.debug) {
					self._ctx.strokeStyle = 'red';
					self._ctx.strokeRect(0, 0, self._canvas.width, self._canvas.height);
				}
			}
			// setTimeout(function(){
			self.animationId = window.requestAnimationFrame(self._animate());
			// }, 1000/60)
		};
	},

	_stopAnimation: function() {
		window.cancelAnimationFrame(this.animationId);
	},

	_updateClipping: function() {
		if (this._ctx == null) return;
		if(!this._map) return;
		this._nw_pt = this._map.latLngToLayerPoint([
			this._opts.bounds.max.y,
			this._opts.bounds.min.x,
		]);
		this._se_pt = this._map.latLngToLayerPoint([
			this._opts.bounds.min.y,
			this._opts.bounds.max.x,
		]);

		this._canvas.width = this._se_pt.x - this._nw_pt.x;
		this._canvas.height = this._se_pt.y - this._nw_pt.y;

		this._boundsWidthDeg = this._opts.bounds.max.x - this._opts.bounds.min.x;
		this._boundsHeightDeg = this._opts.bounds.max.y - this._opts.bounds.min.y;

		this._boundsLngPixelPerDeg = this._canvas.width / this._boundsWidthDeg;
		this._boundsLngDegPerPix = this._boundsWidthDeg / this._canvas.width;
		this._boundsLatPixelPerDeg = this._canvas.height / this._boundsHeightDeg;
		this._boundsLatDegPerPix = this._boundsHeightDeg / this._canvas.height;

		L.DomUtil.setPosition(this._canvas, this._nw_pt);
	},

	grayToValue: function(gray, paramUrl) {
		var min = this._opts.param.range[paramUrl].srcmin;
		var max = this._opts.param.range[paramUrl].srcmax;
		var coef = gray / (this._opts.param.range[paramUrl].dtsmax || 255);
		var value = coef * (max - min) + min;
		return value;
	},

	getValueAt: function(coords) {
		var self = this;
		var raster = this._raster.windf || this._raster.windd;
		if (!raster) return;
		var x =
			(coords.lng - this._opts.bounds.min.x) /
			(this._boundsWidthDeg / raster.imgData.width);
		var y =
			(this._opts.bounds.max.y - coords.lat) /
			(this._boundsHeightDeg / raster.imgData.height);

		/* bilinear interp */
		var lx = x - Math.floor(x);
		var ly = y - Math.floor(y);
		var rx = 1 - lx;
		var ry = 1 - ly;

		var values = {};

		_.each(this._raster, function(raster, key) {
			var width = raster.imgData.width;
			var data = raster.imgData.data;

			var g00 = data[Math.floor(x) * 4 + width * Math.floor(y) * 4];
			var g10 = data[Math.ceil(x) * 4 + width * Math.floor(y) * 4];
			var g01 = data[Math.floor(x) * 4 + width * Math.ceil(y) * 4];
			var g11 = data[Math.ceil(x) * 4 + width * Math.ceil(y) * 4];

			if (Math.max(g00, g10, g01, g11) == 255) {
				var value = data[Math.round(x) * 4 + width * Math.round(y) * 4];
			} else {
				var value =
					g00 * rx * ry + g10 * lx * ry + g01 * rx * ly + g11 * lx * ly;
			}

			var rval = self.grayToValue(value, key);

			if (key == 'windd') {
				rval = rval >= 180 ? 1 * rval - 180 : 1 * rval + 180;
			}

			values[key] = rval;

			// var step = (maxScale - minScale) / 255;
			// var scaledVal = (value == 255) ? null : Math.round((minScale + step * value) * 10) / 10;

			if (self._opts.debug) {
				raster.ctx.fillStyle = self.debugColors[coords.i]
					? self.debugColors[coords.i]
					: 'lime';
				raster.ctx.fillRect(x, y, 1, 1);
			}
		});

		return values;
	},

	_onDidZoom: function() {
		this._updateClipping();
	},

	onRemove: function() {
		this._stopAnimation();
		this._points = [];
		if (this._canvas) this._canvas.remove();
		_.each(this._raster, function(raster) {
			if (raster.ctx.canvas) raster.ctx.canvas.remove();
		});
		this._opts.param.isError = false;
	},
});

L.Layer.canvasParticules = function(opts) {
	return new L.Layer.CanvasParticules(opts);
};
